// Firebase configuration
// Replace these with your actual Firebase project config
// To find this configuration:
// 1. Go to Firebase Console (https://console.firebase.google.com/)
// 2. Select your project
// 3. Click on the web app icon (</>) in the Project Overview
// 4. If you haven't registered a web app yet, click "Add app" and choose web
// 5. After registration, you'll see the configuration in "Add Firebase SDK" step
// 6. Copy the firebaseConfig object below

const firebaseConfig = {
    apiKey: "AIzaSyBFEIe0WrsEcUERtKFcHIfCaa0-6pO2i7s",
    authDomain: "winged-ratio-419707.firebaseapp.com",
    projectId: "winged-ratio-419707",
    storageBucket: "winged-ratio-419707.appspot.com",
    messagingSenderId: "218155424718",
    appId: "1:218155424718:web:88798ac66059c6e560299f",
    measurementId: "G-FMJ1E7BPX8"
  };

export default firebaseConfig; 